
    var riot = require('riot')
    //src: starling/src/tags/modal-sign-up.html
riot.tag2('modal-sign-up',
  '<div class="Modal Modal--Large {this.inviteCode() ? \'Modal--Invite\' : \'\'}"> <header if="{this.showTryNowHeadline()}" class="Modal_header"> <h2 class="Modal_title Modal_title--large"> Visualize your ideas and <br> work together in real-time! </h2> </header> <header if="{this.inviteCode()}" class="Modal_header"> <h3 class="Modal_title Modal_title--large" if="{!this.getInviterName()}"> Sign up to start working together </h3> <h3 class="Modal_title Modal_title--large" if="{this.getInviterName()}"> Sign up to start working with {this.getInviterName()} </h3> </header> <div if="{this.inviteCode()}" class="invite-user_headline"> <img if="{getInviterName()}" class="avatar avatar--medium invite-user_headline_avatar" riot-src="{getInviterAvatar()}"> <div class="invite-user_headline_message"> {this.getInviterName()} invited you to <b>{this.getInviterPermission()}</b> this map </div> </div> <form class="Modal_form" onsubmit="{handleSubmit}"> <input ref="csrf" type="hidden" name="_csrf" riot-value="{window.csrfToken}"> <input if="{this.inviteCode()}" type="hidden" name="inviteCode" riot-value="{this.inviteCode()}"> <span ref="error" class="Modal_form_message Modal_form_message--error" style="display: none;"></span> <label class="Modal_form_label" for="new-email">Email address</label> <input ref="email" class="Modal_form_input" name="email" placeholder="name@email.com" required riot-value="{prefilledEmail()}" type="{\'email\'}"> <label if="{this.showPasswordInput()}" class="Modal_form_label" for="new-email">New Password</label> <input if="{this.showPasswordInput()}" ref="password" class="Modal_form_input" name="password" type="password" placeholder="Create a password" autocomplete="new-password" required> <button ref="submit" class="Button Button--Primary Button--Large Button--Full" type="submit">Sign up for free</button> <a ref="google" href="{getGoogleLoginPath()}" class="Button Button--Outlined Button--Large Button--Full" onmousedown="{trackGoogleSignup}"> <svg class="Button__Icon"> <use xlink:href="#google-icon"></use> </svg> <span class="Button__Label">Sign up with Google</span> </a> <p class="Modal_form_footnote"> By creating an account you agree to the <a href="/terms-of-service">terms of service</a> and <a href="/privacy-policy">privacy policy</a>. </p> <div class="have-account-line" if="{showLoginLink()}">Have an account? <a class="color-blue" href="{getLoginLink()}">Log in</a></div> </form> </div>',
  '',
  'class="Modal_overlay"', function(opts) {
'use strict';

var _this = this;

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.on('mount', function () {
  _eventTracking2.default.track({
    category: 'Signup',
    action: 'Signup-Modal-Shown',
    label: 'Signup-Modal-Shown'
  });
});

this.validateEmail = function (email) {
  return (/\S+@\S+\.\S+/.test(email)
  );
};

this.enableForm = function () {
  var _refs = _this.refs,
      submit = _refs.submit,
      google = _refs.google;

  submit.removeAttribute('disabled');
  google.removeAttribute('disabled');

  _this.isSubmitting = false;
};

this.disableForm = function () {
  var _refs2 = _this.refs,
      submit = _refs2.submit,
      google = _refs2.google;

  submit.setAttribute('disabled', true);
  google.setAttribute('disabled', true);

  _this.isSubmitting = true;
};

this.handleSubmit = function (e) {
  var error = _this.refs.error;

  error.textContent = '';
  error.style.display = 'none';

  if (_this.isSubmitting) return;

  _this.disableForm();

  e.preventDefault();

  var email = _this.refs.email.value;
  if (!_this.validateEmail(email)) {
    _this.refs.email.focus();
    _this.enableForm();
    return;
  }

  var name = email.match(/(\S+)@.*/)[1];

  _eventTracking2.default.track({
    category: 'Signup',
    action: 'Signup-Modal-Submitted',
    label: 'Email-Signup'
  });

  $.ajax({
    method: 'POST',
    url: '/api/sign-up',
    data: {
      name: name,
      email: email,
      password: _this.showPasswordInput() ? _this.refs.password.value : undefined,
      generatePassword: _this.showPasswordInput() ? undefined : true,
      inviteCode: _this.inviteCode(),
      signIn: true,
      _csrf: _this.refs.csrf.value
    }
  }).then(function (result) {

    if (_this.inviteCode()) {
      window.location = window.location.pathname;
    } else {
      window.location = '/maps/new?isTryNow=1';
    }
  }).catch(function (err) {
    var error = _this.refs.error;

    error.style.display = 'block';
    error.textContent = err && err.responseJSON && err.responseJSON.error || 'Unexpected error, please try again later';
    _this.enableForm();
  });
};

this.trackGoogleSignup = function (e) {
  _eventTracking2.default.track({
    category: 'Signup',
    action: 'Signup-Modal-Submitted',
    label: 'Google-Signup'
  });
};

this.prefilledEmail = function () {
  if (!window.invite.inviteEmail) return '';
  return window.invite.inviteEmail;
};

this.inviteCode = function () {
  if (window.invite) {
    return window.invite.inviteCode;
  }
};

this.showPasswordInput = function () {
  if (window.invite) return true;
  return false;
};

this.showTryNowHeadline = function () {
  if (window.invite) return false;
  return true;
};

this.getInviter = function () {
  if (!window.invite) return;
  return window.invite.inviter;
};

this.getInviterName = function () {
  if (window.invite && window.invite.inviter) {
    return window.invite.inviter.display_name || window.invite.inviter.email;
  }
};

this.getInviterAvatar = function () {
  if (window.invite && window.invite.inviter) {
    return window.invite.inviter.avatar_url;
  }
  return '/images/avatar.png';
};

this.getInviterPermission = function () {
  if (window.invite && window.invite.permission) {
    return window.invite.permission;
  }
  return 'view';
};

this.getGoogleLoginPath = function () {
  if (_this.inviteCode()) {
    return '/auth/google?path=' + encodeURIComponent(window.location.pathname) + '&inviteCode=' + encodeURIComponent(_this.inviteCode());
  }
  return '/auth/google?path=/start-try';
};

this.showLoginLink = function () {
  if (_this.inviteCode()) return true;
  return false;
};

this.getLoginLink = function () {
  if (_this.inviteCode()) {
    return '/login?path=' + encodeURIComponent(window.location.pathname) + '&inviteCode=' + encodeURIComponent(_this.inviteCode());
  }
  return '/login';
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-sign-up')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-sign-up.html
// module id = 771
// module chunks = 0